export default "__VITE_ASSET__aN10kGbG__"